export default "__VITE_ASSET__DPG6UpzV__"